module.exports = __webpack_public_path__ + "1487793_10201492545172520_1837105887_o.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1487793_10201492545172520_1837105887_o.jpg
// module id = 821
// module chunks = 0